var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSliceRing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 323,
    height: 539,
    viewBox: "0 0 323 539",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M307.697 340.857C268.406 475.606 127.312 552.989 -7.43696 513.697C-142.186 474.405 -219.57 333.317 -180.278 198.568C-140.985 63.8141 0.103597 -13.5698 134.852 25.7218",
    stroke: "url(#paint0_linear_25_587)",
    strokeWidth: 30,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25_587",
    x1: -196.255,
    y1: 193.906,
    x2: 323.672,
    y2: 345.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01A0C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00390625,
    stopColor: "#029FC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0078125,
    stopColor: "#039FC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0117188,
    stopColor: "#049EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#059EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0195313,
    stopColor: "#069DC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0234375,
    stopColor: "#079CC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0273438,
    stopColor: "#089CC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#089BC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0351563,
    stopColor: "#099BC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0390625,
    stopColor: "#0A9AC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0429688,
    stopColor: "#0B99C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#0C99C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507812,
    stopColor: "#0D98C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546875,
    stopColor: "#0E97C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0585938,
    stopColor: "#0F97C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#1096C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0664063,
    stopColor: "#1196C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703125,
    stopColor: "#1295C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0742188,
    stopColor: "#1394C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#1494C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0820313,
    stopColor: "#1593C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#1693C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0898438,
    stopColor: "#1692C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#1791BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0976562,
    stopColor: "#1891BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101562,
    stopColor: "#1990BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105469,
    stopColor: "#1A90BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#1B8FBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113281,
    stopColor: "#1C8EBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117188,
    stopColor: "#1D8EBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121094,
    stopColor: "#1E8DBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#1F8CBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128906,
    stopColor: "#208CBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132813,
    stopColor: "#218BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136719,
    stopColor: "#228BBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#238ABC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.144531,
    stopColor: "#2489BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148438,
    stopColor: "#2489BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152344,
    stopColor: "#2588BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#2688BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.160156,
    stopColor: "#2787BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164063,
    stopColor: "#2886BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167969,
    stopColor: "#2986BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#2A85BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175781,
    stopColor: "#2B85BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "#2C84B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183594,
    stopColor: "#2D83B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#2E83B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.191406,
    stopColor: "#2F82B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "#3082B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199219,
    stopColor: "#3181B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#3280B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207031,
    stopColor: "#3280B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210938,
    stopColor: "#337FB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.214844,
    stopColor: "#347EB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#357EB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222656,
    stopColor: "#367DB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226562,
    stopColor: "#377DB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.230469,
    stopColor: "#387CB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#397BB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238281,
    stopColor: "#3A7BB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "#3B7AB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246094,
    stopColor: "#3C7AB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#3D79B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253906,
    stopColor: "#3E78B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257813,
    stopColor: "#3F78B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261719,
    stopColor: "#4077B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#4077B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269531,
    stopColor: "#4176B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#4275B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277344,
    stopColor: "#4375B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#4474B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285156,
    stopColor: "#4574B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289063,
    stopColor: "#4673B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292969,
    stopColor: "#4772B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#4872B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300781,
    stopColor: "#4971B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#4A70B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308594,
    stopColor: "#4B70B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#4C6FB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316406,
    stopColor: "#4D6FB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320313,
    stopColor: "#4E6EAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324219,
    stopColor: "#4E6DAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#4F6DAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332031,
    stopColor: "#506CAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#516CAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339844,
    stopColor: "#526BAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#536AAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347656,
    stopColor: "#546AAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351563,
    stopColor: "#5569AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355469,
    stopColor: "#5669AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#5768AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363281,
    stopColor: "#5867AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#5967AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371094,
    stopColor: "#5A66AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#5B65AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378906,
    stopColor: "#5C65AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#5C64AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386719,
    stopColor: "#5D64AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#5E63AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394531,
    stopColor: "#5F62AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#6062AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402344,
    stopColor: "#6161A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#6261A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.410156,
    stopColor: "#6360A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#645FA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417969,
    stopColor: "#655FA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#665EA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425781,
    stopColor: "#675EA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#685DA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433594,
    stopColor: "#695CA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#6A5CA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441406,
    stopColor: "#6A5BA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#6B5BA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449219,
    stopColor: "#6C5AA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#6D59A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457031,
    stopColor: "#6E59A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#6F58A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464844,
    stopColor: "#7057A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#7157A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472656,
    stopColor: "#7256A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#7356A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480469,
    stopColor: "#7455A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#7554A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488281,
    stopColor: "#7654A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#7753A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496094,
    stopColor: "#7853A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7852A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503906,
    stopColor: "#7951A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#7A51A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511719,
    stopColor: "#7B50A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#7C50A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519531,
    stopColor: "#7D4FA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#7E4EA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527344,
    stopColor: "#7F4EA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#804DA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535156,
    stopColor: "#814DA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#824CA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542969,
    stopColor: "#834B9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#844B9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.550781,
    stopColor: "#854A9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#86499F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558594,
    stopColor: "#86499E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#87489E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566406,
    stopColor: "#88489E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#89479E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574219,
    stopColor: "#8A469D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#8B469D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582031,
    stopColor: "#8C459D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#8D459C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589844,
    stopColor: "#8E449C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#8F439C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597656,
    stopColor: "#90439C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#91429B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605469,
    stopColor: "#92429B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#93419B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613281,
    stopColor: "#94409A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#95409A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621094,
    stopColor: "#953F9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#963E9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628906,
    stopColor: "#973E99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#983D99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636719,
    stopColor: "#993D99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#9A3C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644531,
    stopColor: "#9B3B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#9C3B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652344,
    stopColor: "#9D3A98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#9E3A97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660156,
    stopColor: "#9F3997"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#A03897"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667969,
    stopColor: "#A13897"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#A23796"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675781,
    stopColor: "#A33796"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#A33696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683594,
    stopColor: "#A43595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#A53595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691406,
    stopColor: "#A63495"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#A73495"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699219,
    stopColor: "#A83394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#A93294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707031,
    stopColor: "#AA3294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#AB3194"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714844,
    stopColor: "#AC3093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#AD3093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722656,
    stopColor: "#AE2F93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#AF2F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730469,
    stopColor: "#B02E92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#B12D92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738281,
    stopColor: "#B12D92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#B22C91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746094,
    stopColor: "#B32C91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#B42B91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753906,
    stopColor: "#B52A90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#B62A90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761719,
    stopColor: "#B72990"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#B82990"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769531,
    stopColor: "#B9288F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773437,
    stopColor: "#BA278F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777344,
    stopColor: "#BB278F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#BC268F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785156,
    stopColor: "#BD268E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#BE258E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792969,
    stopColor: "#BF248E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#BF248D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800781,
    stopColor: "#C0238D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804687,
    stopColor: "#C1228D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808594,
    stopColor: "#C2228D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#C3218C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816406,
    stopColor: "#C4218C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#C5208C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824219,
    stopColor: "#C61F8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#C71F8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832031,
    stopColor: "#C81E8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835937,
    stopColor: "#C91E8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839844,
    stopColor: "#CA1D8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#CB1C8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847656,
    stopColor: "#CC1C8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#CD1B8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855469,
    stopColor: "#CD1B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#CE1A89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863281,
    stopColor: "#CF1989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867187,
    stopColor: "#D01988"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871094,
    stopColor: "#D11888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#D21788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878906,
    stopColor: "#D31788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#D41687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886719,
    stopColor: "#D51687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#D61587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.894531,
    stopColor: "#D71486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898437,
    stopColor: "#D81486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902344,
    stopColor: "#D91386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#DA1386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910156,
    stopColor: "#DB1285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#DB1185"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917969,
    stopColor: "#DC1185"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#DD1085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925781,
    stopColor: "#DE1084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929687,
    stopColor: "#DF0F84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933594,
    stopColor: "#E00E84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#E10E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.941406,
    stopColor: "#E20D83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#E30D83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949219,
    stopColor: "#E40C83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#E50B82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.957031,
    stopColor: "#E60B82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960937,
    stopColor: "#E70A82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964844,
    stopColor: "#E80981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#E90981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972656,
    stopColor: "#E90881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#EA0881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980469,
    stopColor: "#EB0780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#EC0680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988281,
    stopColor: "#ED0680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992187,
    stopColor: "#EE0580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996094,
    stopColor: "#EF057F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0047F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliceRing);
export default __webpack_public_path__ + "static/media/slice-ring.c4fb27d8489d979ebc3173b7094dd702.svg";
export { ForwardRef as ReactComponent };